import { render, staticRenderFns } from "./CatalogForm.vue?vue&type=template&id=32fb83ff&scoped=true&"
import script from "./CatalogForm.vue?vue&type=script&lang=js&"
export * from "./CatalogForm.vue?vue&type=script&lang=js&"
import style0 from "./CatalogForm.vue?vue&type=style&index=0&id=32fb83ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fb83ff",
  null
  
)

export default component.exports